import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Grid,
  Grid2,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
  Rating,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DetailPageSide from "../../components/detailPageSideBar/detailPageSide";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import {
  GET_BREADCRUMBS,
  GET_PRODUCT_BY_ID,
  GET_PRODUCT_PROMOTIONS,
  GET_SERVICE_AVAILABILITY,
} from "../../redux/apis";
import "./ProductDetail.css";
import { formatAsFullDate } from "../../utilities/date-utility";
import { getProductReviews } from "../../utilities/reviewUtils";
import { axiosPublicInstance } from "../../redux/axiosInstance";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconBreadcrumbs from "../../components/Breadcrumps/IconBreadcrumbs";
const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const coupons = [
  { id: 1, code: "SAVE10", discount: "Get 10% off on orders above $1000" },
  { id: 2, code: "FREESHIP", discount: "Free shipping on first order" },
  { id: 3, code: "FLAT50", discount: "Flat $50 off on prepaid orders" },
];

const rowStyle = {
  border: '1px solid #ddd',
};

const cellStyle = { padding: '10px', textAlign: 'left' };

const ProductDetail: React.FC = () => {
  const location = useLocation();
  const [data, setData] = useState<any>();
  const [productId, setProductId] = useState<any>();
  const [categoryId, setCategoryId] = useState<any>();
  const [image1, setImage1] = useState([
    require("../../../assets/first.png"),
    require("../../../assets/second.png"),
    require("../../../assets/third.png"),
    require("../../../assets/fourth.png"),
  ]);
  const [pincode, setPincode] = useState("");
  const [pinCodeData, setPinCodeData] = useState<any>();
  const [isInvalidPinCode, setisInvalidPinCode] = useState<boolean>(false);
  const [ind, setInd] = useState(0);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [promotions, setPromotions] = useState<any[]>([]);
  const [tabIndex, setTabIndex] = useState(0);

  const tabData = [
    {
      label: "Description",
      content: "This product is made of high-quality materials and designed for durability and performance.",
    },
    {
      label: "Specification",
      content: "• Power: 1200W\n• Voltage: 220V\n• Warranty: 1 Year\n• Material: Steel & Plastic",
    },
    {
      label: "Instructions",
      content: "1. Read the manual before use.\n2. Ensure proper safety measures while operating.\n3. Store in a dry and cool place.",
    },
  ];


  const handleTabChange = (
    event: any,
    newValue: React.SetStateAction<number>
  ) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    console.log(location.state)
    if (location.state) {
      let productId = location.state;
      setData(null);
      setProductId(productId);
      getProducts(productId);
      // getProductReviews(productId).then((reviewData: any) => {
      const reviewData = {
        "averageRating": 4.5,
        "totalRatings": 3,
        "ratings": [
          {
            "customerName": "Rahim",
            "rating": 5,
            "reviewHeadline": "Excellent camera",
            "reviewText": "Very clear video quality and easy to install.",
            "reviewDate": "2025-02-10"
          },
          {
            "customerName": "Karim",
            "rating": 4,
            "reviewHeadline": "Good value",
            "reviewText": "Works well for home security.",
            "reviewDate": "2025-01-28"
          },
          {
            "customerName": "Anika",
            "rating": 5,
            "reviewHeadline": "Highly recommended",
            "reviewText": "Night vision is amazing!",
            "reviewDate": "2025-01-15"
          }
        ]
      }
      if (reviewData) {
        setReviews(reviewData ? reviewData.ratings : []);
        setTotalRating(reviewData ? reviewData.totalRatings : 0);
        setAverageRating(reviewData ? reviewData.averageRating : 0);
        const ratingCounts = [5, 4, 3, 2, 1].map(rating =>
          reviewData?.ratings?.filter((review: any) => review.rating === rating).length
        );
        setRatingCounts(ratingCounts);
        const ratingPercentages = ratingCounts.map(count => (Math.round((count / reviewData.totalRatings) * 100)));
        setRatingPercentages(ratingPercentages);
      }

      // });
    }
  }, [location.state]);

  const getProducts = async (val: any) => {
    try {
      // const response = await axiosPublicInstance.get(`${GET_PRODUCT_BY_ID}${val}`);
      // if (response) {
      // let datas = response.data;
      let datas = {
        "productId": 101,
        "displayName": "2 MP Built-in Mic Fixed Bullet Network Camera",
        "shortDesc": "High quality surveillance camera with night vision and built-in microphone.",
        "longDesc":
          "<p>This CCTV camera offers crystal clear video quality with advanced night vision technology. Suitable for homes, offices, and commercial use.</p><p>This CCTV camera offers crystal clear video quality with advanced night vision technology. Suitable for homes, offices, and commercial use.</p><p>It comes with a built-in microphone that captures audio clearly, ensuring complete surveillance coverage. The camera is designed to be weather-resistant, making it perfect for both indoor and outdoor use.</p><p> With easy installation and configuration via a mobile app, you can monitor your property from anywhere in real- time.The camera supports multiple mounting options and flexible viewing angles.</p>",
        "salePrice": 3200,
        "mrpPrice": 4000,
        "averageRating": 4.5,
        "totalRatings": 128,
        "saleWarranty": 12,
        "productWeight": 1.5,
        "taxPercent": 15,

        "category": {
          "categoryId": 1,
          "categoryName": "CCTV Camera"
        },

        "productDiscount": {
          "discountType": "PERCENTAGE",
          "discountValue": 20
        },

        "productImageUrl": require('../../../assets/Home/Cctv.png'),

        "productImages": [
          {
            "imageId": 1,
            "imageUrl": require("../../../assets/first.png")
          },
          {
            "imageId": 2,
            "imageUrl": require("../../../assets/second.png")
          },
          {
            "imageId": 3,
            "imageUrl": require("../../../assets/third.png")
          },
          {
            "imageId": 4,
            "imageUrl": require("../../../assets/fourth.png")
          }
        ],

        "productKeyFeatures": [
          { "keyFeatureText": "2 MP Full HD Resolution" },
          { "keyFeatureText": "Built-in Microphone" },
          { "keyFeatureText": "Night Vision up to 30 meters" },
          { "keyFeatureText": "Weather Resistant Body" }
        ],

        "productSpecifications": [
          {
            "specificationLabelName": "Resolution",
            "specificationLabelText": "1920 × 1080"
          },
          {
            "specificationLabelName": "Lens",
            "specificationLabelText": "3.6mm Fixed Lens"
          },
          {
            "specificationLabelName": "Power Supply",
            "specificationLabelText": "12V DC"
          },
          {
            "specificationLabelName": "Operating Temperature",
            "specificationLabelText": "-10°C to 50°C"
          }
        ],

        "installationInstruction": "<ul><li>Mount the camera securely</li><li>Connect power supply</li><li>Configure using mobile app</li></ul>",
        "productRelations": [
          {
            "productRelationId": 1,
            "productId": 101,
            "relatedProductId": 102,
            "slimProduct": {
              "productId": 102,
              "productName": "16 GB SD Card",
              "productImageUrl": require("../../../assets/came.png"),
              "mrpPrice": 800,
              "salePrice": 650,
              "taxPercent": 5,
              "productDiscount": { "discountType": "FIXED_AMOUNT", "discountValue": 50 },
              "availableQuantity": 50
            }
          },
          {
            "productRelationId": 2,
            "productId": 101,
            "relatedProductId": 103,
            "slimProduct": {
              "productId": 103,
              "productName": "Camera Mount Stand",
              "productImageUrl": require("../../../assets/third.png"),
              "mrpPrice": 1200,
              "salePrice": 1000,
              "taxPercent": 5,
              "productDiscount": null,
              "availableQuantity": 30
            }
          }
        ],

        "serviceProduct": {
          "productId": 201,
          "productName": "Professional Installation Service",
          "productImageUrl": require("../../../assets/installation.png"),
          "mrpPrice": 1500,
          "salePrice": 1200,
          "taxPercent": 5,
          "productDiscount": { "discountType": "PERCENTAGE", "discountValue": 10 },
          "availableQuantity": 10
        }

      };
      setData(datas);
      setCategoryId(datas.category.categoryId);
      setSelectedImage((datas && datas.productImageUrl) ? datas.productImageUrl :
        (datas.productImages && datas.productImages.length > 0) ? datas.productImages[0].imageUrl :
          require('../../../assets/Home/Cctv.png'));
      getPromotions(datas.productId, datas.category.categoryId);
      // }
    } catch (error) {
      console.log(error);
    }

  };

  const [totalRating, setTotalRating] = useState<any>();
  const [averageRating, setAverageRating] = useState<any>();
  const [reviews, setReviews] = useState<any>([]);
  const [ratingCounts, setRatingCounts] = useState<any>();
  const [ratingPercentages, setRatingPercentages] = useState<any>();


  const getPromotions = async (productId: any, categoryId: any) => {
    try {
      // const response = await axiosPublicInstance.get(GET_PRODUCT_PROMOTIONS + "productId=" + productId + "&categoryId=" + categoryId);
      // if (response.status == 200) {
      //   console.log(response);
      //   setPromotions(response.data);
      // } else {
      //   console.warn("Empty response");
      // }
      const mockPromotions = [
        {
          "promotionId": 1,
          "promotionType": "COUPON",
          "shortDescription": "Get 10% off on this product",
          "couponCode": "SAVE10"
        },
        {
          "promotionId": 2,
          "promotionType": "OFFER",
          "shortDescription": "Flat ₹500 off on prepaid orders"
        }
      ]
      setPromotions(mockPromotions);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const checkServiceAvailability = async () => {

    if (pincode.length < 6) {
      setisInvalidPinCode(true);
    }
    else {
      try {
        const response = await axiosPublicInstance.get(`${GET_SERVICE_AVAILABILITY}?pinCode=${pincode}&weight=${data.productWeight}`);
        if (response && response.data && response.data.serviceable) {
          setPinCodeData(response.data);
        }
        else {
          setPinCodeData(null);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handlePinCodeChange = (e) => {
    setPinCodeData(null);
    setisInvalidPinCode(false);
    const newValue = e.target.value;
    // Allow only digits and limit input to 6 characters
    if (/^\d{0,6}$/.test(newValue)) {
      setPincode(newValue);
    }
  };

  const [copied, setCopied] = useState(null);

  const handleCopy = (code: any) => {
    navigator.clipboard.writeText(code);
    setCopied(code);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <>
      <Header />
      {/* width: (WIDTH * 90) / 100,  */}
      <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', marginTop: '105px' }}>
        <Box sx={{ pl: 1, pb: 1 }} >
          <IconBreadcrumbs categoryId={categoryId} />
        </Box>
        <Box display={"flex"} flexDirection={"row"} mb={4}>
          <Grid2 container spacing={2}>
            <Grid2 size={{
              xs: 12,
              lg: 9
            }}>
              <Box sx={{
                margin: 'auto',
                backgroundColor: 'white',
                borderRadius: '10px',
                border: '1px solid rgba(0, 0, 0, 0.2)',
                boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.15), -2px -2px 5px rgba(255, 255, 255, 0.6)',
                // padding: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Paper sx={{ p: 4 }} style={{ borderRadius: 10 }}>
                  <Grid2 container spacing={5}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <Box sx={{ position: "relative", }}>
                        <img
                          src={selectedImage}
                          alt="Main Product"
                          style={{ width: "100%", borderRadius: 4 }}
                        />
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "white",
                          }}
                        >
                          <FavoriteBorderIcon />
                        </IconButton>
                        <Grid
                          container
                          spacing={1}
                          sx={{ mt: 2 }}
                          style={{ alignItems: "center" }}
                        >
                          <Grid item>
                            <IconButton>
                              <ArrowBackIosIcon />
                            </IconButton>
                          </Grid>
                          <Box
                            sx={{
                              display: "flex",
                              overflowX: "auto", // Enable horizontal scrolling
                              gap: 2, // Spacing between grid items
                              "&::-webkit-scrollbar": {
                                height: "8px", // Optional: Custom scrollbar styling
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#888",
                                borderRadius: "10px",
                              },
                            }}
                          >
                            {data &&
                              data.productImages &&
                              data.productImages.length != 0
                              ? data.productImages.map((item: any, index: any) => (
                                <Grid
                                  item
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={() => {
                                    setInd(index);
                                    setSelectedImage(item.imageUrl);
                                  }}
                                >
                                  <img
                                    src={data.productImages[index].imageUrl}
                                    alt={`Thumbnail ${index + 1}`}
                                    style={{
                                      width: 50,
                                      height: 40,
                                      borderRadius: 4,
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                </Grid>
                              ))
                              : null}
                          </Box>
                          <Grid item>
                            <IconButton>
                              <ArrowForwardIosIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Box>
                      <Box sx={{ mt: 4 }}>
                        <CardContent>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            CodeGigz Benefits
                          </Typography>
                          <List
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              padding: 0,
                              mb: 4
                            }}
                          >
                            {[
                              {
                                title: "GST Invoice Available",
                                images: require("../../../assets/money.png"),
                              },
                              {
                                title: "Secure Payments",
                                images: require("../../../assets/shielding.png"),
                              },
                              {
                                title: "365 Days Help Desk",
                                images: require("../../../assets/timer.png"),
                              },
                            ].map((benefit, index) => (
                              <ListItem
                                sx={{
                                  width: "45%",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "5px",
                                  boxSizing: "border-box",
                                  borderWidth: 1,
                                  borderColor: "#DDDDDD",
                                  borderStyle: "solid",
                                  mb: 1,
                                  ml: 2,
                                  borderRadius: 2,
                                }}
                                key={index}
                              >
                                <img
                                  src={benefit.images}
                                  alt="Product"
                                  style={{ marginRight: "5px" }}
                                />
                                <ListItemText
                                  sx={{
                                    "& .MuiListItemText-primary": {
                                      fontSize: "13px",
                                      whiteSpace: "nowrap",
                                    },
                                  }}
                                  primary={benefit.title}
                                />
                              </ListItem>
                            ))}
                          </List>

                          <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Return & Warranty Policy
                          </Typography>
                          <List
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              padding: 0,
                            }}
                          >
                            {[
                              {
                                title: "7 Days Brand Replacement",
                                images: require("../../../assets/replace.png"),
                              },
                              {
                                title: "Missing Product",
                                images: require("../../../assets/missing.png"),
                              },
                              {
                                title: "Wrong Product",
                                images: require("../../../assets/wrong.png"),
                              },
                              {
                                title: "Damaged Product",
                                images: require("../../../assets/damage.png"),
                              }
                            ].map((policy, index) => (
                              <ListItem key={index} sx={{
                                width: "45%",
                                display: "flex",
                                alignItems: "center",
                                padding: "5px",
                                boxSizing: "border-box",
                                borderWidth: 1,
                                borderColor: "#DDDDDD",
                                borderStyle: "solid",
                                mb: 1,
                                ml: 2,
                                borderRadius: 2,
                              }}>
                                <img
                                  src={policy.images}
                                  alt="Product"
                                  style={{ marginRight: "5px" }}
                                />
                                <ListItemText
                                  sx={{
                                    "& .MuiListItemText-primary": {
                                      fontSize: "13px",
                                      whiteSpace: "nowrap",
                                    },
                                  }}
                                  primary={policy.title}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </CardContent>

                        {/* <CardContent><Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" sx={{ fontSize: '16px', mb: 1 }}>
                              CodeGigz Benefits
                            </Typography>
                            <List
                              sx={{
                                display: "flex",
                                //flexDirection: "row",
                                flexWrap: "wrap",
                                padding: 0,
                                mb: 4
                              }}
                            >
                              {[
                                {
                                  title: "GST Invoice Available",
                                  images: require("../../../assets/money.png"),
                                },
                                {
                                  title: "Secure Payments",
                                  images: require("../../../assets/shielding.png"),
                                },
                                {
                                  title: "365 Days Help Desk",
                                  images: require("../../../assets/timer.png"),
                                },
                              ].map((benefit, index) => (
                                <ListItem key={index} sx={{
                                  borderWidth: 1,
                                  borderColor: "#DDDDDD",
                                  borderStyle: "solid",
                                  padding: "8px",
                                  mb: 1,
                                  borderRadius: 2,
                                }}>
                                  <img
                                    src={benefit.images}
                                    alt="Product"
                                    style={{ marginRight: "5px" }}
                                  />
                                  <ListItemText
                                    sx={{
                                      "& .MuiListItemText-primary": {
                                        fontSize: "13px",
                                        whiteSpace: "nowrap",
                                      },
                                    }}
                                    primary={benefit.title}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" sx={{ fontSize: '16px', mb: 1 }}>
                              Return & Warranty Policy
                            </Typography>
                            <List
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                padding: 0,
                              }}
                            >
                              {[
                                {
                                  title: "7 Days Brand Replacement",
                                  images: require("../../../assets/replace.png"),
                                },
                                {
                                  title: "Missing Product",
                                  images: require("../../../assets/missing.png"),
                                },
                                {
                                  title: "Wrong Product",
                                  images: require("../../../assets/wrong.png"),
                                },
                                {
                                  title: "Damaged Product",
                                  images: require("../../../assets/damage.png"),
                                }
                              ].map((policy, index) => (
                                <ListItem key={index} sx={{
                                  borderWidth: 1,
                                  borderColor: "#DDDDDD",
                                  borderStyle: "solid",
                                  padding: "8px",
                                  mb: 1,
                                  borderRadius: 2,
                                }}>
                                  <img
                                    src={policy.images}
                                    alt="Product"
                                    style={{
                                      marginRight: "5px",
                                    }}
                                  />
                                  <ListItemText
                                    sx={{
                                      "& .MuiListItemText-primary": {
                                        fontSize: "13px",
                                        whiteSpace: 'nowrap'
                                      },
                                    }}
                                    primary={policy.title}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Grid>
                        </Grid>
                        </CardContent> */}
                      </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <Box sx={{ alignItems: "center" }}>
                        {data?.productDiscount && <Chip
                          label="Hot Sale"
                          color="error"
                          variant="filled"
                          style={{
                            marginBottom: "10px",
                            backgroundColor: "#c92b22",
                            color: "white",
                            fontWeight: "bolder"
                          }}
                        />}
                        <Typography
                          variant="h5"
                          component="h2"
                          sx={{ fontWeight: "bold", color: "black" }}
                        >
                          {data && data.displayName
                            ? data.displayName
                            : ""}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                        <Rating value={averageRating ? averageRating : 0} readOnly precision={0.5} />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                          ({totalRating ? totalRating : 0} reviews)
                        </Typography>
                      </Box>
                      {/* <Typography variant="h6" component="h3" sx={{ mt: 2 }}>
                      Colour
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                      <Button
                        variant="outlined"
                        style={{
                          color: "#F74B81",
                          borderColor: "#F74B81",
                          borderWidth: 1,
                        }}
                      >
                        White
                      </Button>
                      <Button
                        variant="outlined"
                        style={{
                          color: "#8A8A8A",
                          borderColor: "#8A8A8A",
                          borderWidth: 1,
                        }}
                      >
                        Black
                      </Button>
                    </Box> */}
                      <Typography variant="subtitle2" sx={{ mt: 2 }} style={{
                        fontSize: '14px'
                      }}>
                        Check Service availability at your pincode
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          mt: 1,
                          borderColor: "#DDDDDD",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: 3,
                        }}
                        border={1}
                        className="fits"
                      >
                        <img
                          src={require("../../../assets/locs.png")}
                          alt="Main Product"
                          style={{
                            width: "15px",
                            height: "20px",
                            marginLeft: "10px",
                          }}
                        />
                        <TextField
                          size="small"
                          sx={{
                            width: WIDTH < 400 ? "auto" : "auto",
                            alignItems: "center",
                            "& fieldset": {
                              border: "none",
                            },
                            "&:hover fieldset": {
                              border: "none",
                            },
                            "&.Mui-focused fieldset": {
                              border: "none",
                            },
                            "& .MuiInputBase-input": {
                              height: "10px",
                            }
                          }}
                          value={pincode}
                          onChange={handlePinCodeChange}
                          placeholder="Enter your pincode"
                          slotProps={{
                            input: {
                              inputMode: 'numeric',
                            },
                          }}
                        />
                        <Button
                          onClick={checkServiceAvailability}
                          size="small"
                          variant="contained"
                          color="primary"
                          style={{ marginRight: '5px', backgroundColor: '#145e97' }}
                        >
                          CHECK
                        </Button>
                      </Box>
                      {isInvalidPinCode && (
                        <Typography variant="body2" sx={{ mt: 1, color: "red" }}>
                          Please enter a valid pincode
                        </Typography>
                      )}
                      {pinCodeData ? (
                        <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                          {pinCodeData && pinCodeData.estimatedDeleiveryInDays ? (
                            <Button
                              variant="outlined"
                              color="primary"
                              style={{
                                width: "auto",
                                justifyContent: "flex-start",
                                backgroundColor: "#F6FFF5",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: 12,
                                  display: "block",
                                  color: "green",
                                  fontWeight: "600",
                                }}
                                className="algn1"
                              >
                                Delivery available in {pinCodeData.estimatedDeleiveryInDays} days
                              </Typography>
                            </Button>
                          ) : <Button
                            variant="outlined"
                            color="primary"
                            style={{
                              width: "auto",
                              justifyContent: "flex-start",
                              backgroundColor: "#F6FFF5",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: 12,
                                display: "block",
                                color: "red",
                                fontWeight: "600",
                              }}
                              className="algn1"
                            >
                              Sorry. Delivery not available.
                            </Typography>
                          </Button>}
                        </Box>
                      ) : null}
                      <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          style={{
                            width: "auto",
                            justifyContent: "flex-start",
                            backgroundColor: "#F6FFF5",
                          }}
                        >
                          <img
                            src={require("../../../assets/spin.png")}
                            alt="Main Product"
                            style={{ width: "18%" }}
                          />
                          <Typography
                            style={{
                              fontSize: 12,
                              display: "block",
                              color: "green",
                              fontWeight: "700",
                            }}
                            className="algn1"
                          >
                            7 Days Brand Replacement
                          </Typography>
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          style={{ backgroundColor: "#F6FFF5" }}
                        >
                          <img
                            src={require("../../../assets/badge.png")}
                            alt="Main Product"
                            style={{ width: "18%" }}
                          />
                          <Typography
                            style={{
                              fontSize: 12,
                              display: "block",
                              color: "green",
                              fontWeight: "700",
                            }}
                            className="algn1"
                          >
                            {data?.saleWarranty} Months Warranty
                          </Typography>
                        </Button>
                      </Box>
                      <Typography variant="subtitle2" sx={{ mt: 3 }}>
                        {data && data.shortDesc
                          ? data.shortDesc
                          : `The Surveillance Camera is a state-of-the-art CCTV solution designed to provide comprehensive security
                                            monitoring for both residential and commercial properties. With its advanced features and robust
                                            construction, this camera ensures reliable performance and peace of mind.`}
                      </Typography>
                      {data &&
                        data.productKeyFeatures && <>
                          <Typography variant="h6" component="h3" sx={{ mt: 3 }}>
                            Key Features
                          </Typography>
                          <List sx={{ padding: 0 }}>
                            {data.productKeyFeatures.length != 0
                              ? data.productKeyFeatures.map(
                                (feature: any, index: any) => (
                                  <ListItem key={index}>
                                    <img
                                      src={require("../../../assets/checkcircle.png")}
                                      alt="tick"
                                      style={{ marginRight: "10px" }}
                                    />
                                    <Typography variant="body2">
                                      {feature.keyFeatureText}
                                    </Typography>
                                  </ListItem>
                                )
                              ) : ""}
                          </List>
                        </>
                      }

                      {promotions && promotions.length > 0 &&
                        <Box sx={{ padding: 2, mt: 4, backgroundColor: "#82e8932b", borderRadius: 6, border: "1px green dotted" }}>
                          <Typography variant="h6" sx={{ marginBottom: "10px", fontWeight: "bold" }}>
                            Offers & Coupons
                          </Typography>
                          {promotions.map((promotion: any) => (
                            <Box
                              key={promotion.promotionId}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                background: "#fff",
                                padding: "10px",
                                borderRadius: "5px",
                                marginBottom: "8px",
                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                                  {promotion.shortDescription}
                                </Typography>
                                {
                                  promotion.promotionType && promotion.promotionType == 'COUPON' && <Typography variant="body2" sx={{ color: "gray" }}>
                                    Code: <strong>{promotion.couponCode}</strong>
                                  </Typography>
                                }
                              </Box>
                              {promotion.promotionType && promotion.promotionType == 'COUPON' ?
                                <Tooltip title={copied === promotion.couponCode ? "Copied!" : "Click to copy"}>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="success"
                                    onClick={() => handleCopy(promotion.couponCode)}
                                    sx={{ textTransform: "none", color: "#fff" }}
                                  >
                                    {copied === promotion.couponCode ? "Copied!" : "Copy"} <ContentCopyIcon fontSize="small" sx={{ marginLeft: "5px" }} />
                                  </Button>
                                </Tooltip> :
                                <>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="primary">
                                    View
                                    {/* View <VisibilityIcon fontSize="small" sx={{ marginLeft: "5px" }} /> */}
                                  </Button>
                                </>}
                            </Box>
                          ))}
                          {/* <Button variant="contained" color="primary" fullWidth sx={{ mt: 4 }}>
                            VIEW ALL OFFERS
                          </Button> */}
                        </Box>}

                      {/* <Paper elevation={0} sx={{ p: 2, mt: 2 }}>
                        {[
                          "Get Flat 100 Off on CCTV Cameras",
                          "Get GST Invoice and save up to 18%",
                          "EMIs Available on min purchases of Rs. 3000",
                        ].map((offer, index) => (
                          <Box
                            key={index}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Typography variant="body2">{offer}</Typography>
                            <Button variant="outlined" size="small">
                              VIEW
                            </Button>
                          </Box>
                        ))}
                      </Paper> */}


                    </Grid2>
                  </Grid2>
                </Paper>
              </Box>
            </Grid2>
            <Grid2
              size={{
                xs: 12,
                lg: 3
              }}
            // style={{ marginTop: (-HEIGHT * 3.5) / 100, padding: 0 }}
            >
              {data && <Box sx={{
                margin: 'auto',
                backgroundColor: 'white',
                borderRadius: '10px',
                border: '1px solid rgba(0, 0, 0, 0.2)',
                boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.15), -2px -2px 5px rgba(255, 255, 255, 0.6)',
                paddingBottom: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <DetailPageSide pass={data} />
              </Box>}
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            mt: 4,
            width: "100%",
            margin: "auto",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            minHeight: "350px",
            padding: "20px",
          }}
        >
          {/* Tabs Navigation */}
          <Tabs
            value={tabIndex}
            onChange={(_, newIndex) => setTabIndex(newIndex)}
            centered
            sx={{
              "& .MuiTabs-indicator": { backgroundColor: "#c72a22", height: "4px" }, // Custom indicator color
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#555",
                "&.Mui-selected": { color: "#c72a22" }, // Active tab color
                "&:hover": { color: "#c72a22" }, // Hover effect
              },
            }}
          >
            {tabData.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>

          {/* Tab Content */}
          <Box
            sx={{
              marginTop: "20px",
              padding: "20px",
              backgroundColor: "#f9f9f9",
              borderRadius: "5px",
              minHeight: "250px",
            }}
          >
            {tabIndex === 0 && (
              <Box sx={{ p: 1 }}>
                <Typography
                  component="div"
                  dangerouslySetInnerHTML={{ __html: data && data.longDesc ? data.longDesc : "" }}>
                </Typography>
              </Box>
            )}
            {tabIndex === 1 && (
              <Box sx={{ p: 1 }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: "700", mt: 3 }}>
                  Technical Specifications
                </Typography>

                {data?.productSpecifications?.length > 0 ? (
                  <Table sx={{ width: "75%", borderCollapse: "collapse", mt: 2 }}>
                    <TableBody>
                      {data.productSpecifications.map((item: any, index: any) => (
                        <TableRow key={index} sx={{ borderBottom: "1px solid #ddd" }}>
                          <TableCell sx={{ fontWeight: "bolder", width: "30%", py: 1 }}>
                            {item.specificationLabelName}:
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", py: 1 }}>
                            {item.specificationLabelText}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No technical specifications available.
                  </Typography>
                )}
              </Box>
            )}

            {tabIndex === 2 && (
              <Box sx={{ p: 2 }}>
                <Typography
                  component="div"
                  dangerouslySetInnerHTML={{ __html: data && data.installationInstruction ? data.installationInstruction : "" }}>
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        <Box sx={{
          mt: 4,
          mb: 4,
          marginTop: '30px !important',
          marginBottom: '30px !important',
          width: "100%",
          margin: "auto",
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          padding: "20px",
        }}>
          <Accordion
            defaultExpanded
            sx={{ boxShadow: "none" }}
            style={{ backgroundColor: "transparent" }}
          >
            <AccordionSummary>
              <Typography><strong>Reviews & Ratings</strong></Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0, marginBottom: '15px' }}>
              <Card
                variant="outlined"
                style={{ borderRadius: 10, padding: (WIDTH * 3) / 100 }}
              >
                {reviews && reviews.length > 0 ?
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={7} md={6}>
                        <Box display="flex">
                          <Box>
                            <Typography
                              variant="h3"
                              sx={{
                                color: "#4CAF50",
                                marginRight: (WIDTH * 0.3) / 100,
                                fontWeight: "700",
                              }}
                            >
                              {averageRating}
                            </Typography>
                            <Typography variant="body1">{totalRating} Ratings</Typography>
                          </Box>
                          <Box>
                            <Grid container spacing={1} alignItems="center">
                              {ratingCounts && ratingCounts.map((rating: any, index: number) => (
                                <>
                                  <Grid item xs={1}>
                                    <Typography variant="body2">{index + 1}</Typography>
                                  </Grid>
                                  <Grid item xs={1}>
                                    <img
                                      src={require("../../../assets/greenstar.png")}
                                      alt="star"
                                      style={{}}
                                    />
                                  </Grid>
                                  <Grid item xs={9}>
                                    <LinearProgress
                                      sx={{
                                        height: "7px",
                                        "& .MuiLinearProgress-bar": {
                                          backgroundColor: "#3BB77E",
                                        },
                                        backgroundColor: "#E8E8E8",
                                      }}
                                      variant="determinate"
                                      value={ratingPercentages[index]}
                                    />
                                  </Grid>
                                  <Grid item xs={1}>
                                    <Typography variant="body2">{ratingPercentages[index]}%</Typography>
                                  </Grid>
                                </>
                              ))}
                            </Grid>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </> :
                  <> <strong>No Reviews</strong></>}
              </Card>
            </AccordionDetails>
          </Accordion>

          {reviews && reviews.length > 0 && <Accordion
            sx={{ boxShadow: "none" }}
            defaultExpanded
            style={{ backgroundColor: "transparent" }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography><strong>All Reviews ({totalRating})</strong></Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: 0 }}>
              {reviews && reviews.map((review: any, index: number) => (
                <Paper key={index} sx={{ p: 3, my: 2, borderRadius: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item>
                      <Avatar>{review.customerName.charAt(0)}</Avatar>
                    </Grid>
                    <Grid item xs>
                      <Box display="flex" justifyContent="space-between" width="100%">
                        {/* Name on the left */}
                        <Typography variant="subtitle2">
                          <strong>{review.customerName}</strong>
                        </Typography>

                        {/* Rating on the right */}
                        <Box display="flex" alignItems="center">
                          <Rating value={review.rating} readOnly />
                          {/* <Typography variant="body2" color="textSecondary" sx={{ ml: 1 }}>
                            {review.rating}
                          </Typography> */}
                        </Box>
                      </Box>

                      {/* <Box display="flex" justifyContent="space-between">
                        <Typography variant="subtitle2">
                          <strong>{review.customerName}</strong>
                        </Typography>
                        <Rating value={review.rating} readOnly />
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ ml: 1 }}
                        >
                          {review.rating}
                        </Typography>
                        {/* <Box display="flex" alignItems="center" sx={{ mt: 1 }}>
                        <Button
                          startIcon={<ThumbUpAltOutlinedIcon />}
                          size="small"
                        >
                          120
                        </Button>
                        <Button
                          startIcon={<ThumbDownAltOutlinedIcon />}
                          size="small"
                          sx={{ ml: 2 }}
                        >
                          20
                        </Button>
            </Box> 
              </Box>*/}
                      <Box
                        display="flex"
                        style={{ marginBottom: (HEIGHT * 0.5) / 100 }}
                      >
                        <Typography
                          variant="overline"
                          color="textSecondary"
                          style={{
                            marginRight: (WIDTH * 2) / 100,
                            // color: "#EC0000",
                          }}
                        >
                          <strong> {formatAsFullDate(review.reviewDate)}</strong>
                        </Typography>
                        {/* <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ color: "#3BB77E" }}
                      >
                        Verified Purchase
                      </Typography> */}
                      </Box>
                      {/* <Box display="flex" alignItems="center">
                        <Rating value={review.rating} readOnly />
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ ml: 1 }}
                        >
                          {review.rating}
                        </Typography>
                      </Box> */}
                      <Box display="flex" alignItems="center">
                        <Typography variant="subtitle2" sx={{ mt: 1 }}>
                          <strong> {review.reviewHeadline}</strong>
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          {review.reviewText}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                </Paper>
              ))}
            </AccordionDetails>
          </Accordion>}
        </Box>



        {/* <Box
          flexDirection={"row"}
          display={"flex"}
          style={{
            marginTop: (HEIGHT * 3) / 100,
            marginBottom: (HEIGHT * 3) / 100,
          }}
        >
          <Button
            variant="contained"
            style={{
              height: 45,
              backgroundColor: "white",
              borderRadius: 20,
              color: "#DC2626",
            }}
            onClick={() => handleTabChange("", 0)}
          >
            <strong> Description </strong>
          </Button>
          <Button
            variant="contained"
            style={{
              height: 45,
              backgroundColor: "white",
              borderRadius: 20,
              color: "#7E7E7E",
              marginLeft: "30px",
            }}
            onClick={() => handleTabChange("", 1)}
          >
            <strong>Specification</strong>
          </Button>
          <Button
            variant="contained"
            style={{
              height: 45,
              backgroundColor: "white",
              borderRadius: 20,
              color: "#7E7E7E",
              marginLeft: "30px",
            }}
            onClick={() => handleTabChange("", 2)}
          >
            <strong>Instruction</strong>
          </Button>
        </Box>

        <Card variant="outlined" style={{ borderRadius: 10 }}>
          <CardContent>
            {tabIndex === 0 && (
              <Box>
                <Typography
                  component="div"
                  dangerouslySetInnerHTML={{ __html: data && data.longDesc ? data.longDesc : "" }}>
                </Typography>
              </Box>
            )}
            {tabIndex === 1 && (
              <Box sx={{ p: 2 }}>
                <Typography variant="body1">
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{ fontWeight: "700", marginTop: "20px" }}
                  >
                    Technical Specifications
                  </Typography>
                  <table style={{ width: '75%', borderCollapse: 'collapse' }}>
                    <tbody>

                      {data &&
                        data.productSpecifications &&
                        data.productSpecifications.length !== 0 ? (
                        data.productSpecifications.map(
                          (
                            item: {
                              specificationLabelName: string;
                              specificationLabelText: string;
                            },
                            index: React.Key | null | undefined
                          ) => (
                            <tr key={index} style={rowStyle}>
                              <td style={{ padding: '10px', textAlign: 'left', fontWeight: 'bolder', width: '30%' }}>{item.specificationLabelName} : </td>
                              <td style={{ padding: '10px', textAlign: 'left', fontWeight: 'bold' }}>{item.specificationLabelText}</td>
                            </tr>
                          )
                        )
                      ) : ""}
                    </tbody>
                  </table>
                </Typography>
              </Box>
            )}

            {tabIndex === 2 && (
              <Box sx={{ p: 2 }}>
                <Typography
                  component="div"
                  dangerouslySetInnerHTML={{ __html: data && data.installationInstruction ? data.installationInstruction : "" }}>
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card> */}




        {/* <Box mt={4}>
          <Typography
            variant="h5"
            gutterBottom
            style={{ marginBottom: (HEIGHT * 3) / 100 }}
          >
            Accessories for your product
          </Typography>
          <Grid
            container
            spacing={2}
            style={{ marginBottom: (HEIGHT * 10) / 100 }}
          >
            {accessories.map((accessory, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={2.3}
                key={index}
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    boxShadow: 2,
                  }}
                  className={styles.BestBox}
                >
                  <Box
                    style={{
                      width: "100%",
                      alignItems: "center",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      display: "flex",
                    }}
                  >
                    <Box
                      component="img"
                      src={require("../../../assets/Home/Like.png")}
                    />
                    <Box
                      component="img"
                      src={require("../../../assets/hot.png")}
                    />
                  </Box>
                  <Box
                    style={{
                      height: (HEIGHT / 100) * 23,
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: (HEIGHT / 100) * 1,
                      marginBottom: (HEIGHT / 100) * 1,
                      width: "100%",
                    }}
                  >
                    <Box
                      component="img"
                      // resizeMode='contain'
                      style={{ width: "80%", height: (HEIGHT * 23) / 100 }}
                      src={require("../../../assets/Home/Cctv.png")}
                    />
                  </Box>
                  <label className={styles.bestText1}>Category</label>
                  <Box style={{}}>
                    <label className={styles.bestText}>
                      2 MP Build-in Mic Fixed Bullet Network Camera
                    </label>
                  </Box>
                  <Box
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box style={{ flexDirection: "row", alignItems: "center" }}>
                      <label className={styles.orgText}>$2000</label>
                      <label className={styles.crsText}>$5000</label>
                    </Box>
                    <Box sx={{ "& .MuiRating-icon": { fontSize: 10 } }}>
                      <Rating value={4} readOnly size={"small"} />
                    </Box>
                    <Box style={{ flexDirection: "row", alignItems: "center" }}>
                      <label className={styles.starCount}>(4.5)</label>
                    </Box>
                  </Box>
                  <Box
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      marginTop: (HEIGHT / 100) * 1,
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <Checkbox name="antoine" {...label} />
                    <Button
                      variant='outlined'
                      color="success"
                      size="small"
                      style={{ marginRight: '0px', marginLeft: '55px' }}
                      sx={{
                        paddingLeft: '19px',
                        minWidth: '10px'
                      }}
                      aria-label='Buy Now'
                      startIcon={<PaymentIcon />}></Button>
                    <Button
                      variant='outlined'
                      color="warning"
                      size="small"
                      sx={{
                        paddingLeft: '19px',
                        minWidth: '10px'
                      }}
                      style={{ marginRight: '10px', marginLeft: '10px' }}
                      startIcon={<ShoppingCartIcon />}></Button>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box> */}
      </Container>
      <Footer />
    </>
  );
};

export default ProductDetail;
